import { createSlice } from "@reduxjs/toolkit";
import {
    PartnerRoleType,
    RolePermissionDetailType,
    UserDetailType,
    UserListType,
    UserRolePermissionsType
} from "./Types";

type initialStateType = {
    fetchedUserListPartnerID: number;
    userList: UserListType;
    userListHID: UserListType;
    userListPartnerGlobal: UserListType;
    userDetail: UserDetailType | null;
    userRolePermissions: UserRolePermissionsType;
    partnerRoles: PartnerRoleType[];
    hidRoles: PartnerRoleType[];
    rolePermissionDetail: RolePermissionDetailType | null;
    toggleUserEnableID: number;
    status: {
        userListLoading: boolean;
        userListHIDLoading: boolean;
        userListPartnerGlobalLoading: boolean;
        userDetailLoading: boolean;
        addUserLoading: boolean;
        addUserStatus: boolean;
        addUserMessage: string;
        updateUserLoading: boolean;
        updateUserStatus: boolean;
        updateUserMessage: string;
        deleteUserLoading: boolean;
        deleteUserStatus: "idle" | "success" | "error";
        deleteUserMessage: string;
        toggleUserEnableLoading: boolean;
        userRolePermissionsLoading: boolean;
        partnerRolesLoading: boolean;
        hidRolesLoading: boolean;
        rolePermissionDetailLoading: boolean;
        editUserRolePermissionsLoading: boolean;
        editUserRolePermissionsStatus: boolean;
        sendAccountInviteLoading: boolean;
        sendAccountInviteStatus: "idle" | "success" | "error";
        sendAccountInviteMessage: string;
    };
}

var initialState: initialStateType = {
    fetchedUserListPartnerID: 0,
    userList: [],
    userListHID: [],
    userListPartnerGlobal: [],
    userDetail: null,
    userRolePermissions: undefined,
    partnerRoles: [],
    hidRoles: [],
    rolePermissionDetail: null,
    toggleUserEnableID: 0,
    status: {
        userListLoading: false,
        userListHIDLoading: false,
        userListPartnerGlobalLoading: false,
        userDetailLoading: false,
        addUserLoading: false,
        addUserStatus: false,
        addUserMessage: "",
        updateUserLoading: false,
        updateUserStatus: false,
        updateUserMessage: "",
        deleteUserLoading: false,
        deleteUserStatus: "idle",
        deleteUserMessage: "",
        toggleUserEnableLoading: false,
        userRolePermissionsLoading: false,
        partnerRolesLoading: false,
        hidRolesLoading: false,
        rolePermissionDetailLoading: false,
        editUserRolePermissionsLoading: false,
        editUserRolePermissionsStatus: false,
        sendAccountInviteLoading: false,
        sendAccountInviteStatus: "idle",
        sendAccountInviteMessage: "",
    },
};

const userSlice = createSlice({
    name : "user",
    initialState : initialState,
    reducers : {
        setFetchedUserListPartnerID: (state, action) => {
            state.fetchedUserListPartnerID = action.payload; 
        },
        setUserList: (state, action) => {
            state.userList = action.payload; 
        },
        setUserDetail: (state, action) => {
            state.userDetail = action.payload; 
        },
        resetUserDetail: (state) => {
            state.userDetail = null;
        },
        setUserListLoading: (state, action) => {
            state.status.userListLoading = action.payload; 
        },
        setAddUserLoading: (state, action) => {
            state.status.addUserLoading = action.payload; 
        },
        setAddUserStatus: (state, action) => {
            state.status.addUserStatus = action.payload; 
        },
        setAddUserMessage: (state, action) => {
            state.status.addUserMessage = action.payload; 
        },
        setUpdateUserLoading: (state, action) => {
            state.status.updateUserLoading = action.payload; 
        },
        setUpdateUserStatus: (state, action) => {
            state.status.updateUserStatus = action.payload; 
        },
        setUpdateUserMessage: (state, action) => {
            state.status.updateUserMessage = action.payload;
        },
        resetUserFormStatus: (state) => {
            state.status.addUserLoading = false;
            state.status.addUserStatus = false;
            state.status.addUserMessage = "";
            state.status.updateUserLoading = false;
            state.status.updateUserStatus = false;
            state.status.updateUserMessage = "";
        },
        setDeleteUserLoading: (state, action) => {
            state.status.deleteUserLoading = action.payload; 
        },
        setDeleteUserStatus: (state, action) => {
            state.status.deleteUserStatus = action.payload; 
        },
        setDeleteUserMessage: (state, action) => {
            state.status.deleteUserMessage = action.payload;
        },
        resetDeleteUserStatus: (state) => {
            state.status.deleteUserLoading = false;
            state.status.deleteUserStatus = "idle";
            state.status.deleteUserMessage = "";
        },
        setUserListHID: (state, action) => {
            state.userListHID = action.payload; 
        },
        setUserListHIDLoading: (state, action) => {
            state.status.userListHIDLoading = action.payload; 
        },
        setUserListPartnerGlobal: (state, action) => {
            state.userListPartnerGlobal = action.payload;
        },
        setUserListPartnerGlobalLoading: (state, action) => {
            state.status.userListPartnerGlobalLoading = action.payload;
        },
        setUserRolePermissions: (state, action) => {
            state.userRolePermissions = action.payload; 
        },
        setUserRolePermissionsLoading: (state, action) => {
            state.status.userRolePermissionsLoading = action.payload; 
        },
        setPartnerRoles: (state, action) => {
            state.partnerRoles = action.payload;
        },
        setPartnerRolesLoading: (state, action) => {
            state.status.partnerRolesLoading = action.payload;
        },
        setHidRoles: (state, action) => {
            state.hidRoles = action.payload;
        },
        setHidRolesLoading: (state, action) => {
            state.status.hidRolesLoading = action.payload;
        },
        setRolePermissionDetail: (state, action) => {
            state.rolePermissionDetail = action.payload;
        },
        setRolePermissionDetailLoading: (state, action) => {
            state.status.rolePermissionDetailLoading = action.payload;
        },
        setEditUserRolePermissionsLoading: (state, action) => {
            state.status.editUserRolePermissionsLoading = action.payload; 
        },
        setEditUserRolePermissionsStatus: (state, action) => {
            state.status.editUserRolePermissionsStatus = action.payload; 
        },
         setToggleUserEnableLoading : (state, action) => {
            state.status.toggleUserEnableLoading = action.payload;
        },
        setToggleUserEnableID : (state, action) => {
            state.toggleUserEnableID = action.payload;
        },
        setSendAccountInviteLoading : (state, action) => {
            state.status.sendAccountInviteLoading = action.payload;
        },
        setSendAccountInviteStatus : (state, action) => {
            state.status.sendAccountInviteStatus = action.payload;
        },
        setSendAccountInviteMessage : (state, action) => {
            state.status.sendAccountInviteMessage = action.payload;
        },
        resetSendAccountInviteStatus : (state) => {
            state.status.sendAccountInviteStatus = "idle";
            state.status.sendAccountInviteMessage = "";
        },
    }
})

export const userSliceReducer = userSlice.reducer;
export const userSliceAction = userSlice.actions;